import { useTranslation } from 'react-i18next';
import React, { useEffect, useMemo } from 'react';
import { MintIdBanner } from '../MintIdBanner';
import cx, { clsx } from 'clsx';
import style from './index.module.scss';
import { UserPermissionRes } from '@/hooks';
import { formatTimeReadableV2 } from '@/utils';
import { useUserTrial } from '@/hooks/trial';
export const PostCountBanner = (props: {
  used_count?: number;
  total_count?: number;
  wait_seconds?: number;
}) => {
  const { t } = useTranslation();

  const { used_count = 0, total_count = 0, wait_seconds = 0 } = props;

  const isDisabled = useMemo(() => {
    return used_count >= total_count;
  }, [used_count, total_count]);

  const waitTime = useMemo(() => formatTimeReadableV2(wait_seconds), [wait_seconds]);
  return (
    <div className={cx(style.postCountBanner, isDisabled && style.isDisabled)}>
      <span>
        {t('PermissionBanner.qd8nht', { amount: total_count })}{' '}
        {isDisabled ? <span>{t('PermissionBanner.gwnmr8', { time: waitTime })}</span> : null}
      </span>

      <span>
        ({used_count}/{total_count})
      </span>
    </div>
  );
};
// 只有试用期结束和sybil不可以发布post 和 comment
export const PermissionBanner = (props: {
  permissionData?: UserPermissionRes;
  currentUserInfo?: UserInfo;
  setDisabled: (disabled: boolean) => void;
  inComment?: boolean;
  onClickMint?: () => void;
}) => {
  const { permissionData, currentUserInfo, setDisabled, inComment, onClickMint } = props;
  const { t } = useTranslation();

  const { data: trialInfo } = useUserTrial(inComment ? 'COMMENT' : 'POST');

  const isSybil = useMemo(
    () => Boolean(currentUserInfo?.desc?.is_spam),
    [currentUserInfo?.desc?.is_spam],
  );

  const isTrialReached = useMemo(() => trialInfo && !trialInfo?.is_active, [trialInfo]);

  const disabledBanner = useMemo(() => {
    const isPermissionDisabled = permissionData && !permissionData?.has_permission;
    return Boolean(isSybil || isPermissionDisabled || isTrialReached);
  }, [isSybil, isTrialReached, permissionData]);

  useEffect(() => {
    setDisabled(!currentUserInfo || disabledBanner);
  }, [setDisabled, currentUserInfo, disabledBanner]);

  if (!permissionData || !trialInfo || !currentUserInfo) {
    return null;
  }

  return (
    <>
      {disabledBanner ? (
        isTrialReached ? (
          <MintIdBanner
            isSybil={isSybil}
            className={clsx(style.MintIdBanner, inComment && style.inComment)}
            inComment={inComment}
            onClickMint={onClickMint}
          />
        ) : (
          <div className={style.hasNoPermissionBanner}>{t('ArticleContent.disabledComment')}</div>
        )
      ) : null}
    </>
  );
};
